var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SensorContainer = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _Sensor = _interopRequireDefault(require("./Sensor"));
var SensorContainer = exports.SensorContainer = function() {
    function SensorContainer() {
        (0, _classCallCheck2.default)(this, SensorContainer);
        this.nativeSensors = new Map();
    }
    (0, _createClass2.default)(SensorContainer, [
        {
            key: "getSensorId",
            value: function getSensorId(sensorType, config) {
                return sensorType * 100 + config.iosReferenceFrame * 10 + Number(config.adjustToInterfaceOrientation);
            }
        },
        {
            key: "initializeSensor",
            value: function initializeSensor(sensorType, config) {
                var sensorId = this.getSensorId(sensorType, config);
                if (!this.nativeSensors.has(sensorId)) {
                    var newSensor = new _Sensor.default(sensorType, config);
                    this.nativeSensors.set(sensorId, newSensor);
                }
                var sensor = this.nativeSensors.get(sensorId);
                return sensor.getSharedValue();
            }
        },
        {
            key: "registerSensor",
            value: function registerSensor(sensorType, config, handler) {
                var sensorId = this.getSensorId(sensorType, config);
                if (!this.nativeSensors.has(sensorId)) {
                    return -1;
                }
                var sensor = this.nativeSensors.get(sensorId);
                if (sensor && sensor.isAvailable() && (sensor.isRunning() || sensor.register(handler))) {
                    sensor.listenersNumber++;
                    return sensorId;
                }
                return -1;
            }
        },
        {
            key: "unregisterSensor",
            value: function unregisterSensor(sensorId) {
                if (this.nativeSensors.has(sensorId)) {
                    var sensor = this.nativeSensors.get(sensorId);
                    if (sensor && sensor.isRunning()) {
                        sensor.listenersNumber--;
                        if (sensor.listenersNumber === 0) {
                            sensor.unregister();
                        }
                    }
                }
            }
        }
    ]);
    return SensorContainer;
}();
